'use client';

import React from 'react';
import { ActivityIcon } from 'src/components/Activity/components';
import { useGetActivityTypesQuery } from 'src/api/redux';

interface ActivityTypeLabelProps {
  activityId: number;
}

const ActivityTypeLabel = ({ activityId }: ActivityTypeLabelProps) => {
  const { data: allActivities } = useGetActivityTypesQuery();
  const activityList = allActivities?.results;

  const targetActivity = activityList?.find(
    (activity) => activity.id === activityId
  );
  const label = targetActivity?.label;

  return (
    <div className="flex items-center whitespace-nowrap w-full">
      <ActivityIcon
        item={targetActivity}
        height="1.5rem"
        width="1.5rem"
        iconSize=".75rem"
      />
      <span className="pl-2 text-neutral-800">{label}</span>
    </div>
  );
};

export default ActivityTypeLabel;
